import { render, staticRenderFns } from "./SiteSwitch.vue?vue&type=template&id=6252b7c9"
import script from "./SiteSwitch.vue?vue&type=script&lang=ts"
export * from "./SiteSwitch.vue?vue&type=script&lang=ts"
import style0 from "./SiteSwitch.vue?vue&type=style&index=0&id=6252b7c9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports